import { render, staticRenderFns } from "./listServices.vue?vue&type=template&id=72949b71&scoped=true"
import script from "./listServices.vue?vue&type=script&lang=js"
export * from "./listServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72949b71",
  null
  
)

export default component.exports